import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiReturnsAvailableParcels } from '@/entities/returns/modules/api/returns';

export const useParcelsAvailableForReturn = () =>
  useFetch({
    api: apiReturnsAvailableParcels,
    keywords: queryKeys.parcels.availableForReturn,
    staleTime: 60_000,
  });
